// @ts-check
// Ponto de entrada da SPA: tema, estilos e montagem da raiz.
import { html, render } from 'htm/preact';
import { App } from './app/app.js';
import { startThemeEffect } from './app/theme.js';
import { isMockEnabled } from './data/api-client.js';
import './styles/base.css';
import './styles/components.css';
import './styles/shell.css';
import './styles/record-table.css';
import './styles/record-board.css';
import './styles/record-show.css';
import './styles/side-panel.css';
import './styles/record-page.css';
import './styles/auth-settings.css';
import './styles/conversations.css';
import './styles/dashboards.css';
import './styles/geo-map.css';
import './styles/team.css';
import './styles/settings-data-model.css';
import './styles/spreadsheet-import.css';
import './styles/automations.css';
import './styles/integrations.css';
import './styles/calendar.css';
import './styles/visits.css';
import './styles/operations.css';
import './styles/admin.css';
import './styles/parity.css';
import './styles/trash.css';
import './styles/board-table.css';
import './styles/workspace-settings.css';
import './styles/api-reference.css';
import './styles/views-filters.css';
import './styles/email.css';
import './styles/family-postcode.css';
import './styles/release-notes.css';
// 2.0.0 (spec-2.0.0 seção 5.2, regra 8): um arquivo por frente; menu Campanhas e telas comuns (passo 0), LGPD (1A),
// público (1B), editor de e-mail (1C), WhatsApp (1D e 2B) e fluxos (2D)
import './styles/campaigns.css';
import './styles/marketing-consent.css';
import './styles/audiences.css';
import './styles/email-design.css';
import './styles/whatsapp-campaigns.css';
import './styles/flows.css';
// 3.0.0 (contrato 10 de atendimento, seção 24): um arquivo por frente; atendimento (F3), bots (F4) e retenção (F5)
import './styles/service-desk.css';
import './styles/bots.css';
import './styles/retention.css';
// páginas de agendamento (3.0.0, frente F6)
import './styles/booking.css';
// por último: as regras de celular completam as de cada tela (contrato 08 de navegação)
import './styles/navigation-mobile.css';
// identidade visual do Matrícula Mais (3.1.0): tokens da marca por cima do tema e de cada tela
import './styles/brand.css';
import { startClientErrorReporter } from './lib/client-error-reporter.js';
import { loadAppEnvironment } from './lib/app-environment.js';

startThemeEffect();
// Lido cedo para fixar ?mock=1 no localStorage antes de qualquer requisição.
const isMock = isMockEnabled();
startClientErrorReporter();
loadAppEnvironment({ isMock });

const root = document.getElementById('root');
if (root) render(html`<${App} />`, root);
